import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "absolute top-0 left-0 w-full flex flex-row items-center justify-center pt-9" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/logo-text.svg",
    class: "h-[65px]"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "w-full h-full flex flex-col fixed top-0 left-0 bg-cover py-9 px-9 items-center justify-center",
    style: _normalizeStyle(`background-image: url('/images/auth_bg_unwind.png')`)
  }, [
    _hoisted_1,
    _renderSlot(_ctx.$slots, "default")
  ], 4))
}